/**
 * useBucketPerformance — reads marketing.content_bucket_performance_v.
 * One row per active bucket with organic + paid metrics from any Studio
 * drafts that were published + optionally boosted.
 */
import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export interface BucketPerformance {
  bucket_slug: string;
  bucket_name: string | null;
  color_accent: string | null;
  posts: number;
  reach_total: number;
  interactions_total: number;
  likes_total: number;
  comments_total: number;
  avg_engagement_pct: number | null;
  ads: number;
  spend_total: number;
  impressions_total: number;
  paid_reach_total: number;
  clicks_total: number;
  avg_cpm: number | null;
  cost_per_reach: number | null;
  cost_per_click: number | null;
}

export function useBucketPerformance() {
  return useQuery<BucketPerformance[]>({
    queryKey: ['bucket-performance'],
    queryFn: async () => {
      const { data, error } = await marketing.from('content_bucket_performance_v').select('*');
      if (error) throw error;
      return (data ?? []) as BucketPerformance[];
    },
    staleTime: 5 * 60_000,
  });
}
